export default __webpack_public_path__ + "static/media/206.2f6c3699.png";